/**
 * 考试模版列表
 * @author jzhu
 * @date 2020-04-02
 */
import {component_tool} from '../../../tool'
import moment from "moment";
import {WizClassifySelect} from "../../common";
import React from "react";
import HighSet from "@/containers/common/highSet";

let {WizModal} = component_tool

let componentName = 'examTemplate'
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '模版名称',
    name: 'title',
    searchItem: {},
    tableItem: {
      width: 200
    }
  },
  {
    title: '考试分类',
    name: 'categoryTypeIds',
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '考试分类',
          tips: '请选择考试分类'
        },
        treeProps: { checkStrictly: true },
        checkable: false
      },
      apiProps: { type: 0 },
      selectProps: {
        placeholder: '请选择考试分类'
      },
    }
  },
  {
    title: '考试分类',
    name: 'categoryType',
    tableItem: {}
  },
  {
    title: '状态',
    name: 'state',
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'}
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '创建人',
    name: 'creator',
    tableItem: {}
  },
  {
    title: '创建时间',
    name: 'createTime',
    tableItem: {
      render: (text) => {
        return formatterDate(text)
      }
    }
  },
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'delete', 'export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: {icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/examTemplate/examTemplateDetailAdd'
              }
            }
          },
          {
            key: "export",
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {},
              },
              formatParams: (rows, record, filter) => {
                return {...filter};
              }
            },
          },
        ]
      },
      rowOperateSort: ['look', 'update', 'enableOrDisable','advancedSet'],//英文
      rowOperateView: [
        {
          key: 'advancedSet',
          custom: true,
          params: { children: '高级设置' },
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <HighSet data={{ record: e.record, bizType: 40 }}
                      changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          // recordChangeParams: ({ record, rows }) => {
          //   let disabled = false
          //   if (record && record['status'] === 2) {
          //     disabled = true
          //   }
          //   return { disabled }
          // }
        },
        {
          key: 'look',
          custom: true,
          params: {children: '查看'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/online/examTemplate/examTemplateLook'
            }
          }
        },
        {
          key: 'update',
          custom: true,
          params: {children: '编辑'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/online/examTemplate/examTemplateDetailUpd'
            }
          }
        },
        {
          key: 'enableOrDisable',
          custom: true,
          params: {children: '启用'},
          textFormat: {
            recordKey: 'state',
            dirt: {0: '启用', 1: '禁用'}
          },
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'enable'
            },
            formatParams: (rows, record, filters, callback) => {
              const content = '您确定要' + (record.state === 1 ? '禁用' : '启用') + '该考试模版吗？'
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record.state === 1 ? 0 : 1,
                    ids: [record.id],
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        }
      ],
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        loading: false
      },
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  categoryList: {
    path: 'categoryType/categoryList',
    payload: {
      key: `${componentName}@categoryList`,
      apiParams: {type: 0}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {},
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'categoryList'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
